import http from "services/httpService";
import { rupeesToNumber } from "utlis/utils";

const GmcPlanSetup = async (values, loading) => {
  // getting business user id
  const business_user_id = localStorage.getItem("id");
  // getting userplan_ids -> it would be different for different plans
  const userplan_ids = localStorage.getItem("userplan_ids");
  // creating a object withe in compulsory values
  const postDataFormat = {
    business_type: "GMC",
    premium_id: values.premium_id,
    business_user_id: localStorage.getItem("id"),
    insurer_name: values && values.insurer,
    benefit_type: values?.benefit_type,
    dependent_type: values && values.dependent_type,
    sum_insured: values && values.sum_insured,
    room_limit: values && values.room_limit,
    maternity_coverage: values && values.maternity_coverage,
    utilization_limit_for_parents:
      values && values.utilization_limit_for_parents,
    disease_wise_limit: values && values.disease_wise_limit,
    co_pay: values && values.co_pay,
    waiting_period: values && values.waiting_period,
    opd_included: values && values.opd_included,
    corporate_buffer: values && values.corporate_buffer,
    premium_contribution: values && values.premium_contribution,
    ambulance_limit: (values && values.ambulance_limit) || "",
    wellness_benefits_options: values && values.wellness_benefits_options,
    
  };

  if (values.room_limit === "Customise Limit (by metro & Non metro)") {
    const { metro_normal, metro_icu, non_metro_normal, non_metro_icu, customized_room_limit } = values;

    if(customized_room_limit){
    postDataFormat.customized_room_limit = {
      metro: {
        normal: (metro_normal && rupeesToNumber(metro_normal)) || "",
        icu: (metro_icu && rupeesToNumber(metro_icu)) || "",
      },
      non_metro: {
        normal: (non_metro_normal && rupeesToNumber(non_metro_normal)) || "",
        icu: (non_metro_icu && rupeesToNumber(non_metro_icu)) || "",
      },
    }}else{
      postDataFormat.customized_room_limit = null
    }
  }

  if (values.maternity_coverage === true) {
    const {
      metro_normal_delivery,
      metro_icu_maternity,
      non_metro_normal_delivery_limit,
      non_metro_icu_limit,
      maternity_coverage_limit
    } = values;
    if(maternity_coverage_limit){
    postDataFormat.maternity_coverage_limit = {
      metro: {
        normal:
          (metro_normal_delivery && rupeesToNumber(metro_normal_delivery)) ||
          "",
        icu: (metro_icu_maternity && rupeesToNumber(metro_icu_maternity)) || "",
      },
      non_metro: {
        normal:
          (non_metro_normal_delivery_limit &&
            rupeesToNumber(non_metro_normal_delivery_limit)) ||
          "",
        icu: (non_metro_icu_limit && rupeesToNumber(non_metro_icu_limit)) || "",
      },
    };} else{
      postDataFormat.maternity_coverage_limit = null
    }
  }
  if (values.maternity_coverage === true){
    postDataFormat.baby_coverage_limit = (values.baby_coverage_limit) || ''
  }

  if ((values.disease_wise_limit = "Yes")) {
    const { disease_name, disease_eligibility_criteria, disease_limit } =
      values;
    postDataFormat.disease_wise_limit = {
      name: disease_name || "",
      eligibility_criteria: disease_eligibility_criteria || "",
      limit: (disease_limit && rupeesToNumber(disease_limit)) || "",
    };
  }

  if (values.co_pay !== "No") {
    const { co_pay_condition } = values;
    postDataFormat.co_pay_condition = co_pay_condition;
  }

  if (values.opd_included == true) {
    const { opd_limit } = values;
    postDataFormat.opd_limit = (opd_limit && rupeesToNumber(opd_limit));
  }
  if(values.corporate_buffer === true){
    const { corporate_buffer_limit } = values;
    postDataFormat.corporate_buffer_limit = ( corporate_buffer_limit && rupeesToNumber(corporate_buffer_limit)) || ''
  }
  if(values.disease_wise_limit === 'Yes'){
    const { disease_wise_refer_policydoc } = values
    if(disease_wise_refer_policydoc){
    postDataFormat.disease_wise_limit = values.disease_wise_limit_detail
    } else {
      postDataFormat.disease_wise_limit = null
    }
  } else{
    postDataFormat.disease_wise_limit = []
  }
  if(values.wellness_benefits_options === 'Yes'){
    postDataFormat.wellness_benefits = values.wellness_benefits
  }

  try {
    let { data } = await http.post("/business/setupplan/", postDataFormat);

    if (!userplan_ids) {
      // creating a new local storage for userplan_ids and storing the strigified value
      localStorage.setItem("userplan_ids", JSON.stringify([data.userplan_id]));
    } else {
      // adding the new userplan_id if it already exist
      const parsed = JSON.parse(userplan_ids);
      localStorage.setItem(
        "userplan_ids",
        JSON.stringify([...parsed, data.userplan_id])
      );
    }
    // loading(false);
    return true;
  } catch (err) {
    console.log({ err });
    alert("Some error has occured!");
    // loading(false);
    return false;
  }
};
export default GmcPlanSetup;
